import { createSelector,createFeatureSelector } from "@ngrx/store";
import { CourseState } from "../reducers/courseChange.reducers";


export const selectCourse = createFeatureSelector<CourseState>('course');

export const selectCourseId = createSelector(
	selectCourse,(state) =>state.courseId
);